"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterValueInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const types_1 = require("@framework/types");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const ParameterValueInput = (props) => {
    const { name = "parameterValue" } = props;
    const parameterType = (0, react_hook_form_1.useWatch)({ name: "parameterType" });
    if (parameterType !== types_1.ParameterType.ENUM) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: name });
};
exports.ParameterValueInput = ParameterValueInput;
//# sourceMappingURL=index.js.map